import {Component, Input, OnInit} from '@angular/core';
import {CampaignForm} from '@app/@core/advertising/campaign/campaign-form';
import {CampaignDraft} from "@app/@core/advertising/campaign/campaign-draft";
import {ConfigService} from "@app/@core/@config/config.service";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-campaign-city[campaignForm]',
  templateUrl: './campaign-city.component.html',
  styleUrls: ['./campaign-city.component.scss']
})
export class CampaignCityComponent implements OnInit {
  @Input() campaignForm!: FormGroup;

  constructor(public configService: ConfigService) { }

  ngOnInit(): void {
  }
}
